import NTopNBottom from '../../components/NTopNBottom'
import calcRemFn from '../calcRem'

import bannerImg from '../../assets/literature2022/banner.jpg'
import navColor from '../../assets/literature2022/nav/color.jpg'
import navBgFixed from '../../assets/literature2022/nav/nav_bg_fix.png'

import p1_1_1 from '../../assets/literature2022/ctn/1_1_1.jpg'
import p1_1_2 from '../../assets/literature2022/ctn/1_1_2.jpg'
import p1_1_3 from '../../assets/literature2022/ctn/1_1_3.jpg'
import p1_1_4 from '../../assets/literature2022/ctn/1_1_4.jpg'
import p1_1_5 from '../../assets/literature2022/ctn/1_1_5.jpg'
import p1_1_6 from '../../assets/literature2022/ctn/1_1_6.jpg'
import p1_2_1 from '../../assets/literature2022/ctn/1_2_1.jpg'
import p1_2_2 from '../../assets/literature2022/ctn/1_2_2.jpg'
import p2_1_1 from '../../assets/literature2022/ctn/2_1_1.jpg'
import p2_1_2 from '../../assets/literature2022/ctn/2_1_2.jpg'
import p2_1_3 from '../../assets/literature2022/ctn/2_1_3.jpg'
import p2_1_4 from '../../assets/literature2022/ctn/2_1_4.jpg'
import p2_2_1 from '../../assets/literature2022/ctn/2_2_1.jpg'
import p2_2_2 from '../../assets/literature2022/ctn/2_2_2.jpg'
import p3_1_1 from '../../assets/literature2022/ctn/3_1_1.jpg'
import p3_1_2 from '../../assets/literature2022/ctn/3_1_2.jpg'
import p3_1_3 from '../../assets/literature2022/ctn/3_1_3.jpg'
import p3_2_1 from '../../assets/literature2022/ctn/3_2_1.jpg'
import p3_2_2 from '../../assets/literature2022/ctn/3_2_2.jpg'
import pFirst from '../../assets/literature2022/ctn/first.jpg'
import pEnd from '../../assets/literature2022/ctn/end.jpg'

const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'


// 需要手动修改proId
const top1_id = IS_PROD ? '102313' : '102313'
const top2_id = IS_PROD ? '102314' : '102314'
const top3_id = IS_PROD ? '102315' : '102315'

const navCss = {
  navWrap: {
    minHeight: calcRemFn(120),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(120),
    transition: 'all 0.3s ease'
  },
  navCtnFixed: {
    height: calcRemFn(120),
    backgroundImage: `url(${navBgFixed})`,
    backgroundPosition: `0 0`,
  },
  topBtnLayout: {
    marginLeft: `${calcRemFn(10)}`,
    width: calcRemFn(126),
    flexWrap: 'wrap',
  },
  topBtnBaseCss: {
    width: calcRemFn(126),
    height: calcRemFn(40),
    opacity: 0,
  },
  bottomBtnLayout: {
    padding: `0`,
    width: calcRemFn(234),
  },
  bottomBtnBaseCss: {
    width: calcRemFn(117),
    height: calcRemFn(120),
    opacity: 0
  }
}

const navData = {
  component: NTopNBottom,
  css: ['a','b','c'],
  top: [
    {
      key: 'top1',
      show: true,
    },
    {
      key: 'top2',
      show: true,
    },
    {
      key: 'top3',
      show: true,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        prodId: top1_id
      },
      {
        key: '_i2',
        show: true,
        prodId: top1_id
      },
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        prodId: top2_id
      },
      {
        key: '_i2',
        show: true,
        prodId: top2_id
      },
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        prodId: top3_id
      },
      {
        key: '_i2',
        show: true,
        prodId: top3_id
      },
    ],
  }
}

const pictures = [
  {
    type: 'blue',
    son: [pFirst]
  },
  {
    id: top1_id,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1_1,
      p1_1_2,
      p1_1_3,
      p1_1_4,
      p1_1_5,
      p1_1_6,
    ],
    name: '单人-彩色'
  },
  {
    id: top1_id,
    type: 'blue',
    ref: 'top1_i2',
    farName: 'top1',
    sonName: '_i2',
    son: [
      p1_2_1,
      p1_2_2,
    ],
    name: '单人-黑白'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p2_1_1,
      p2_1_2,
      p2_1_3,
      p2_1_4,
    ],
    name: '好友-彩色'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i2',
    farName: 'top2',
    sonName: '_i2',
    son: [
      p2_2_1,
      p2_2_2
    ],
    name: '好友-黑白'
  },
  {
    id: top3_id,
    type: 'blue',
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [
      p3_1_1,
      p3_1_2,
      p3_1_3,
    ],
    name: '情侣-彩色'
  },
  {
    id: top3_id,
    type: 'blue',
    ref: 'top3_i2',
    farName: 'top3',
    sonName: '_i2',
    son: [
      p3_2_1,
      p3_2_2,
      pEnd
    ],
    name: '情侣-彩色'
  }
]

const topDiff = {
  firstSon: '_i1',
  top1_i1: 78,
  top2_i1: 90,
  top3_i1: 90,
}

export default {
  title: '第101种美',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
